import { render, staticRenderFns } from "./goodsCard.vue?vue&type=template&id=f06076a8&scoped=true"
import script from "./goodsCard.vue?vue&type=script&lang=js"
export * from "./goodsCard.vue?vue&type=script&lang=js"
import style0 from "./goodsCard.vue?vue&type=style&index=0&id=f06076a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06076a8",
  null
  
)

export default component.exports